declare const process: any;
const BASE_URL = (process.env.REACT_APP_API_BASE as string | undefined) || 'http://127.0.0.1:5000';
const FrontendURL ='https://book.triointernational.net';
const API_URLS = {
    AUTH: {
        LOGIN: `${BASE_URL}/users/login`,
        REGISTER: `${BASE_URL}/users/register`,
        VERIFY_OTP: `${BASE_URL}/users/verify-otp`,
        RESEND_OTP: `${BASE_URL}/users/resend-otp`,
        LOGOUT: `${BASE_URL}/users/logout`,
    },
    USER: {
        GET_PROFILE: `${BASE_URL}/user/profile`,
        UPDATE_PROFILE: `${BASE_URL}/user/update-profile`,
        DELETE_ACCOUNT: `${BASE_URL}/user/delete-account`,
        GET_UI_PROFILE: `${FrontendURL}/user/profile-settings`,
    },
    POSTS: {
        GET_ALL: `${BASE_URL}/api/posts`,
        GET_BY_ID: (id: string) => `${BASE_URL}/api/posts/${id}`,
        CREATE: `${BASE_URL}/api/posts/create`,
        UPDATE: (id: string) => `${BASE_URL}/api/posts/update/${id}`,
        DELETE: (id: string) => `${BASE_URL}/api/posts/delete/${id}`,
    },
    FLIGHTS: {
        // SEARCH_LOCATION: `${BASE_URL}/flights/search-location?keyword=`,
        SEARCH_LOCATION: `${BASE_URL}/airport_routes/airports/search?q=`,
        REALTIME_FLIGHT: `${BASE_URL}/flights/real-time`,
        FLIGHT_OPTIONS: `${BASE_URL}/flights/flight-options`,
        FLIGHT_DETAILS: `${BASE_URL}/flights/flight-details`,
        SAVE_PASSENGERS: `${BASE_URL}/flights/save-passengers`,
        REVIEW_PASSENGERS: `${BASE_URL}/flights/review-passengers`,
        SSR: `${BASE_URL}/flights/ssr`,
        SAVE_SSR: `${BASE_URL}/flights/save-ssr`,
        CONFIRM_BOOKING: `${BASE_URL}/flights/confirm-booking`,
        HOLD_FLIGHT: `${BASE_URL}/flights/hold-flight`,
        COMPLETE_HELD_BOOKING: `${BASE_URL}/flights/complete-held-booking`,
        CALENDAR_FARES: `${BASE_URL}/flights/calendar-fare`,
        INSURANCE: {
            SEARCH_INSURANCE: `${BASE_URL}/insurance/search`,
        },
        MY_BOOKINGS: `${BASE_URL}/flights/my-flight-bookings`,
        CANCELLATION: `${BASE_URL}/flights/cancel`,
        DOWNLOAD_TICKET: (pnr: string) => `${BASE_URL}/flights/download/ticket/${pnr}`,
        DOWNLOAD_INVOICE: (pnr: string) => `${BASE_URL}/flights/download/invoice/${pnr}`,
        LOCK_PRICE_CONFIG: `${BASE_URL}/flights/lock-price-config`,
    },
    COUPONS: {
        ACTIVE: `${BASE_URL}/admin_offer/coupons/active`,
        VALIDATE: `${BASE_URL}/admin_offer/coupons/validate`,
        USE: `${BASE_URL}/admin_offer/coupons/use`,
    },
    BOT: {
  GET_MESSAGE: `${BASE_URL}/bot/get-message`,
  FLIGHT_SEARCHED_LIST: `${FrontendURL}/flight/flight-list`,
  HOTEL_SEARCHED_GRID: `${FrontendURL}/hotel/hotel-grid`,
  REQUEST_CALLBACK: `${BASE_URL}/bot/request-callback`,
},

    PAYMENTS: {
        CREATE_ORDER: `${BASE_URL}/payments/create-payment-order`,
        VERIFY_PAYMENT: `${BASE_URL}/payments/verify-payment`,
        REFUND_FLIGHT: `${BASE_URL}/payments/refund-flight`,
    },
    HOTELS: {
        // Step 1: Country & City Search
        SEARCH_CITIES: `${BASE_URL}/Hotels/ui/search_city`,

        // Step 2: Hotel Search & Details
        HOTEL_SEARCH: `${BASE_URL}/Hotels/ui/search_hotels`,
        HOTEL_ROOMS: `${BASE_URL}/Hotels/ui/hotel_rooms`,
        SAVE_GUESTS: `${BASE_URL}/Hotels/save-guests`,
        // Step 3: Booking Flow
        PREBOOK: `${BASE_URL}/Hotels/ui/prebook`,
        BOOK: `${BASE_URL}/Hotels/ui/book`,
        BOOKING_DETAIL: `${BASE_URL}/Hotels/ui/booking_detail`,
        GENERATE_VOUCHER: `${BASE_URL}/Hotels/ui/generate_voucher`,
        MY_BOOKINGS: `${BASE_URL}/Hotels/ui/my-hotel-bookings`,
        CANCELLATION: `${BASE_URL}/Hotels/ui/cancellation`,
    },
    ADMIN: {
  HOTEL_BOOTSTRAP_ALL: `${BASE_URL}/admin_hotel/admin/bootstrap_all`,
}

};

export default API_URLS;